import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import {useStore} from 'vuex'
import cookie from '@/utils/cookie'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {permissions} from '@/apis/Administrator'
import store from "@/store";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login.vue'),
        meta: {
            title: '管理员登录'
        }
    },
    {
        path: '/no-permission',
        name: 'noPermission',
        component: () => import('@/views/no-permission.vue'),
        meta: {
            title: '无权限'
        }
    },
    {
        path: '/',
        name: 'home',
        redirect: '/dashboard',
        component: () => import('@/views/layout.vue'),
        children: [
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('@/views/admin/dashboard.vue'),
                meta: {
                    icon: 'dashboard',
                    title: '概览'
                }
            },
            {
                path: '/permission-point',
                name: 'permissionPoint',
                component: () => import('@/views/admin/permission-point.vue'),
                meta: {
                    icon: 'permission',
                    title: '权限管理'
                }
            },
            {
                path: '/org',
                name: 'org',
                meta: {
                    icon: 'tree',
                    title: '组织架构'
                },
                children: [
                    {
                        path: '/org/staffs',
                        name: 'staffs',
                        component: () => import('@/views/admin/org/staffs.vue'),
                        meta: {
                            icon: 'staff',
                            title: '员工管理'
                        },
                        children: [
                            {
                                path: '/org/staffs/:id',
                                name: 'staffDetail',
                                component: () => import('@/views/admin/org/staff-detail.vue'),
                                meta: {
                                    title: '员工详情',
                                    isHide: true
                                }
                            }
                        ]
                    },
                    {
                        path: '/org/departments',
                        name: 'departments',
                        component: () => import('@/views/admin/org/departments.vue'),
                        meta: {
                            icon: 'department',
                            title: '部门管理'
                        }
                    },
                    {
                        path: '/org/roles',
                        name: 'roles',
                        component: () => import('@/views/admin/org/roles.vue'),
                        meta: {
                            icon: 'role',
                            title: '角色管理'
                        }
                    },
                    {
                        path: '/org/positions',
                        name: 'positions',
                        component: () => import('@/views/admin/org/positions.vue'),
                        meta: {
                            icon: 'position',
                            title: '岗位管理'
                        }
                    },
                ]
            },
            {
                path: '/shops',
                name: 'shops',
                meta: {
                    icon: 'shop',
                    title: '店铺管理',
                    indexTitle: '店铺列表'
                },
                component: () => import('@/views/admin/shop/index.vue'),
                children: [
                    {
                        path: '/shops/certification-applications',
                        name: 'shopCertificationApplications',
                        component: () => import('@/views/admin/shop/certification-applications.vue'),
                        meta: {
                            icon: 'shop',
                            title: '门店认证审核'
                        }
                    },
                    {
                        path: '/shops/:id',
                        name: 'shopDetail',
                        meta: {
                            title: '店铺详情',
                            isHide: true
                        },
                        component: () => import('@/views/admin/shop/detail.vue')
                    }
                ]
            },
            {
                path: '/members',
                name: 'members',
                meta: {
                    icon: 'menu-member',
                    title: '会员管理'
                },
                component: () => import('@/views/admin/members/index.vue'),
                children: [
                    {
                        path: '/members/:id',
                        name: 'memberDetail',
                        meta: {
                            title: '会员详情',
                            isHide: true
                        },
                        component: () => import('@/views/admin/members/detail.vue')
                    }
                ]
            },
            {
                path: '/wallet',
                name: 'wallet',
                component: () => import('@/views/admin/wallet/index.vue'),
                meta: {
                    icon: 'menu-member',
                    title: '钱包管理'
                }
            },
            {
                path: '/orders',
                name: 'orders',
                redirect: '/orders/mall',
                meta: {
                    icon: 'menu-order',
                    title: '订单管理'
                },
                children: [
                    {
                        path: '/orders/mall',
                        name: 'mallOrders',
                        component: () => import('@/views/admin/orders/index.vue'),
                        meta: {
                            icon: 'menu-order',
                            title: '橱窗订单'
                        },
                        children: [
                            {
                                path: '/orders/mall/:id',
                                name: 'mallOrderDetail',
                                meta: {
                                    title: '橱窗订单详情',
                                    isHide: true
                                },
                                component: () => import('@/views/admin/orders/detail.vue')
                            }
                        ]
                    },
                    {
                        path: '/orders/demand',
                        name: 'demandOrders',
                        component: () => import('@/views/admin/orders/demand.vue'),
                        meta: {
                            icon: 'menu-order',
                            title: '任务订单'
                        },
                        children: [
                            {
                                path: '/orders/demand/:id',
                                name: 'demandOrderDetail',
                                meta: {
                                    title: '任务订单详情',
                                    isHide: true
                                },
                                component: () => import('@/views/admin/orders/demand-detail.vue')
                            }
                        ]
                    },
                    {
                        path: '/orders/:id',
                        name: 'orderDetail',
                        redirect: to => `/orders/mall/${to.params.id}`,
                        meta: {
                            title: '订单详情',
                            isHide: true
                        }
                    }
                ]
            },
            {
                path: '/content',
                name: 'content',
                meta: {
                    icon: 'recommend',
                    title: '内容运营'
                },
                children: [
                    {
                        path: '/content/artisan-skill-categories',
                        name: 'artisanSkillCategories',
                        component: () => import('@/views/admin/content/artisan-skill-categories.vue'),
                        meta: {
                            icon: 'category',
                            title: '服务场景分类'
                        }
                    },
                    {
                        path: '/content/topics',
                        name: 'contentTopics',
                        component: () => import('@/views/admin/content/topics.vue'),
                        meta: {
                            icon: 'menu-ad',
                            title: '专题管理'
                        }
                    },
                    {
                        path: '/content/background-music',
                        name: 'backgroundMusic',
                        component: () => import('@/views/admin/content/background-music.vue'),
                        meta: {
                            icon: 'recommend',
                            title: '背景音乐管理'
                        }
                    },
                    {
                        path: '/content/app-versions',
                        name: 'appVersions',
                        component: () => import('@/views/admin/content/app-versions.vue'),
                        meta: {
                            icon: 'recommend',
                            title: 'App版本管理'
                        }
                    },
                    {
                        path: '/content/feedbacks',
                        name: 'feedbacks',
                        component: () => import('@/views/admin/content/feedbacks.vue'),
                        meta: {
                            icon: 'recommend',
                            title: '反馈与聊天举报'
                        }
                    },
                    {
                        path: '/content/opus-reviews',
                        name: 'opusReviews',
                        component: () => import('@/views/admin/content/opus-reviews.vue'),
                        meta: {icon: 'recommend', title: '作品发布审核'}
                    },
                    {
                        path: '/content/demand-publication-reviews',
                        name: 'demandPublicationReviews',
                        component: () => import('@/views/admin/content/demand-publication-reviews.vue'),
                        meta: {icon: 'recommend', title: '任务发布审核'}
                    },
                    {
                        path: '/content/safety-reviews',
                        name: 'contentSafetyReviews',
                        component: () => import('@/views/admin/content/safety-reviews.vue'),
                        meta: {icon: 'recommend', title: '内容安全审核'}
                    },
                    {
                        path: '/content/opus-reports',
                        name: 'opusReports',
                        component: () => import('@/views/admin/content/opus-reports.vue'),
                        meta: {
                            icon: 'recommend',
                            title: '作品举报审核'
                        }
                    },
                    {
                        path: '/content/demand-reports',
                        name: 'demandReports',
                        component: () => import('@/views/admin/content/demand-reports.vue'),
                        meta: {
                            icon: 'recommend',
                            title: '任务举报审核'
                        }
                    },
                    {
                        path: '/content/submissions',
                        name: 'contentSubmissions',
                        component: () => import('@/views/admin/content/submissions.vue'),
                        meta: {
                            icon: 'business-card',
                            title: '精选投稿审核'
                        }
                    },
                    {
                        path: '/content/featured-layout',
                        name: 'featuredLayout',
                        component: () => import('@/views/admin/content/featured-layout.vue'),
                        meta: {
                            icon: 'recommend',
                            title: '精选页编排'
                        }
                    }
                ]
            },
            {
                path: '/marketing',
                name: 'marketing',
                meta: {
                    icon: 'menu-ad',
                    title: '营销管理'
                },
                children: [
                    {
                        path: '/marketing/coupons',
                        name: 'marketingCoupons',
                        component: () => import('@/views/admin/marketing/coupons.vue'),
                        meta: {
                            icon: 'menu-ad',
                            title: '优惠券管理'
                        }
                    }
                ]
            },
            {
                path: '/goods',
                name: 'goods',
                meta: {
                    icon: 'goods',
                    title: '商品管理'
                },
                children: [
                    {
                        path: '/goods/spu',
                        name: 'spu',
                        component: () => import('@/views/admin/goods/spu.vue'),
                        meta: {
                            icon: 'spu',
                            title: '商品列表'
                        },
                        children: [
                            {
                                path: '/goods/spu/:id',
                                name: 'spuDetail',
                                component: () => import('@/views/admin/goods/spu-detail.vue'),
                                meta: {
                                    title: '商品详情',
                                    isHide: true
                                }
                            }
                        ]
                    },
                    {
                        path: '/goods/categories',
                        name: 'categories',
                        component: () => import('@/views/admin/goods/categories.vue'),
                        meta: {
                            icon: 'category',
                            title: '分类管理'
                        }
                    },
                    {
                        path: '/goods/brands',
                        name: 'brands',
                        component: () => import('@/views/admin/goods/brands.vue'),
                        meta: {
                            icon: 'brand',
                            title: '品牌管理'
                        }
                    },
                    {
                        path: '/goods/materials',
                        name: 'materials',
                        component: () => import('@/views/admin/goods/materials.vue'),
                        meta: {
                            icon: 'material',
                            title: '材质管理'
                        }
                    },
                ]
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

const noLoginPagePaths = ['/login', '/no-permission']

// 路由加载前
router.beforeEach(async (to, from, next) => {
    const store = useStore()
    NProgress.start()
    if (!noLoginPagePaths.includes(to.path)) {
        const token = cookie.get('token')
        const permissionPoints = await permissions('page', 'WEB')
        const {path} = to.matched[to.matched.length - 1]
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const permissionPoint = permissionPoints.find((pi: any) => pi.path === path)
        store.commit('setPermissionPoints', permissionPoints)
        if (permissionPoint) {
            if (token) {
                cookie.set('token', token)
                next()
            } else {
                next(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
            }
        } else {
            next('/no-permission')
        }
    } else {
        next()
    }
})

router.afterEach(async (to, from) => {
    NProgress.done()
    document.title = <string>to.meta.title || ''
    if (!noLoginPagePaths.includes(to.path)) {
        const fromPath = from.matched[from.matched.length - 1]?.path
        const toPath = to.matched[to.matched.length - 1]?.path
        if (fromPath !== `${toPath}/:id` && `${fromPath}/:id` !== toPath) {
            store.commit('setCurrentPage', 1)
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const permissionPoints = await permissions('button', 'WEB', `${toPath}`)
        store.commit('setPagePermissionPoints', permissionPoints)
    }
})

export default router
